import { cn } from '@hqo/react-hooks';
import { useState, useCallback } from 'react';
import ImagePlaceholder from 'app/assets/image-placeholder.png';
import { Skeleton } from '@hqo/ui-atoms';
import { useMobileScreen } from 'app/shared/hooks/use-mobile-screen';

interface ImageProps {
  src?: string;
  alt?: string;
  className?: string;
  imageRef?: React.RefObject<HTMLImageElement>;
}

export const Image = ({ src, alt, className, imageRef }: ImageProps) => {
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const onLoadComplete = useCallback(() => setIsLoading(false), [setIsLoading]);
  const { isMobileScreen } = useMobileScreen();
  const customStyles = isMobileScreen ? 'h-[255px] rounded-none' : 'h-screen max-h-[420px] lg:max-h-[420px]';

  const onError = useCallback(() => {
    setIsError(true);
    setIsLoading(false);
  }, [setIsError, setIsLoading]);

  return (
    <>
      <Skeleton
        className={cn(
          'bg-system-grey-medium',
          className,
          customStyles,
          !isLoading && 'hidden',
        )}
      />
      <img
        ref={imageRef}
        src={isError ? ImagePlaceholder : src}
        alt={alt}
        onError={onError}
        onLoad={onLoadComplete}
        className={cn(
          isLoading && 'hidden',
          className,
        )}
      />
    </>
  );
};
